module.exports = __webpack_public_path__ + "static/water_glacier10-ce87ce2043f16cc6fee46d02856ddd73.jpg";